
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 200 200"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"100","cy":"100","r":"100"}}),_c('circle',{attrs:{"fill":"#FFF","cx":"-250.14","cy":"-409.36","r":"30.02","transform":"translate(350.144 472.509)"}}),_c('path',{attrs:{"fill":"#FFF","d":"M150.27 107.72c-2.02-4.67-5.39-11.99-16.01-14.01-2.09-.38-4.2-.56-6.32-.53-1.16 0-2.31.24-3.37.72a56.854 56.854 0 01-24.12 5.14h-.89c-8.33.07-16.56-1.69-24.13-5.14a8.01 8.01 0 00-3.37-.72c-2.12-.04-4.24.14-6.33.53-10.64 2.02-13.99 9.34-16.01 14.01 0 0-16.41 37.98-4.88 53.16 1.74 2.31 4.27 3.9 7.11 4.46 2.48.52 5.03.67 7.56.45 4.86-.36 18.92-.45 40.49-.34 21.57-.11 35.63-.02 40.49.34 2.53.23 5.07.08 7.56-.45a11.49 11.49 0 007.11-4.46c11.53-15.18-4.89-53.16-4.89-53.16zM75.9 146.91h-5.83V119.4h5.83v27.51zm18.61-4.47c1.93 0 4.27-.48 7.02-1.45v4.89c-2.26.94-4.78 1.41-7.56 1.41-4 0-7.06-1.21-9.18-3.64s-3.18-5.91-3.18-10.45c0-2.86.52-5.37 1.56-7.52 1.04-2.15 2.54-3.8 4.49-4.95 1.95-1.15 4.24-1.72 6.86-1.72 2.67 0 5.36.65 8.05 1.94l-1.88 4.74c-1.03-.49-2.06-.92-3.1-1.28s-2.06-.55-3.07-.55c-2.2 0-3.9.82-5.1 2.47-1.2 1.65-1.81 3.95-1.81 6.9 0 6.14 2.3 9.21 6.9 9.21zm35.42 4.47h-5.81v-11.87h-10.9v11.87h-5.83V119.4h5.83v10.78h10.9V119.4h5.81v27.51z"}})])
          )
        }
      }
    